/*global angular*/
var odetGoalConcordances = angular.module('odetGoalConcordances', ['odetManager']);

odetGoalConcordances.directive('odetGoalConcordances', ['odetManager',
  function (odetManager) {
  'use strict';
    return {
      restrict: 'E',
      template: require('./odetGoalConcordances.html'),
      replace: true,
      transclude: true,
      scope: {
        type: '=',
        goal: '=',
        field: '=',
        results: '='
      },
      link: function (scope) {
        function loadConcordances(type) {
          odetManager.getConcordantieByZillGoal(type.key, scope.goal.key)
          .then(function (results) {
            scope.results = results;
          });
        }

        scope.$watch('type', function (n, o) {
          if (n !== o) {
            loadConcordances(n);
          }
        });
        loadConcordances(scope.type);
      }
    };
  }]);

module.exports = odetGoalConcordances;



// WEBPACK FOOTER //
// ./web/js/module/odetGoalConcordances/odetGoalConcordances.js